/// <reference path="../_references.ts"/>

module App.Questionnaire {
	import ServiceableItemType = App.ItemManagement.ServiceableItemType;
	import ServiceRequest = App.Appointments.ServiceRequest;
	import User = App.User.User;

	export class Questionnaire {
		id?: number = null;
		items?: ServiceableItemType[] = [];
		name: string = null;
		questions: Array<QuestionnaireQuestion> = [];
		visible: boolean = true;
		question_count: number = 0;
		short_url?: string;
		first_access_date?: string;

		constructor(data?: Questionnaire) {
			const vm = this;

			data = data || vm;

			vm.id = data.id;
			vm.items = data.items;
			vm.name = data.name;
			vm.questions =  data.questions;
			vm.visible = data.visible;
			vm.question_count = data.question_count;
			vm.short_url = data.short_url;
			vm.first_access_date = data.first_access_date;
		}

		isNew() {
			return +this.id !== +this.id;
		}

		toJSONString() {
			return JSON.stringify(this);
		}
	}

	export type QuestionType = {
		id: number;
		name?: string;
	}

	export type QuestionnaireTokenCreate = {
		questionnaire: number,
		service_request: number,
		serviceable_item: number
	}

	export type QuestionnaireToken = {
		id: number,
		comments: string,
		is_valid?: boolean,
		created_by: User,
		responses: QuestionnaireResponse[],
		service_request: ServiceRequest,
		short_url: string,
		version: QuestionnaireVersion
	}

	export type QuestionnaireResponse = {
		id: number,
		comments: string,
		response: string,
		question: QuestionnaireQuestion
	}

	export type QuestionnaireVersion = {
		id?: number,
		questions: QuestionnaireQuestion[],
		questionnaire: Questionnaire
	}

	export type QuestionnaireResponseCreate = {
		question: number,
		response: string
	}

	export class QuestionnaireQuestion {
		id?: number = null;
		type?: QuestionType = null;
		question?: string = null;
		details?: string = null;
		choices?: string[];
		data?: string[];
		display_id: number = null;
		photo1?: string = null;
		photo2?: string = null;
		photo3?: string = null;
		photo4?: string = null;
		visible: boolean = true;
		response?: string = null;

		constructor(data?: QuestionnaireQuestion) {
			const vm = this;

			data = data || vm;

			vm.id = data.id;
			vm.type = data.type;
			vm.question = data.question;
			vm.details = data.details;
			vm.data = data.data;
			vm.choices = data.choices;
			vm.display_id = data.display_id;
			vm.photo1 = data.photo1;
			vm.photo2 = data.photo2;
			vm.photo3 = data.photo3;
			vm.photo4 = data.photo4;
			vm.visible = data.visible;
			vm.response = data.response;
		}
	}
}